//
export default [
    {
        align: 'left',
        sortable: 'false',
        text: 'ID',
        value: 'id',
    },
    {
        text: 'Codigo interno',
        align: 'left',
        sortable: 'false',
        value: 'internal_code',
    },
    {
        text: 'Nombre',
        align: 'left',
        sortable: 'false',
        value: 'name',
    },
    {
        text: 'Items',
        align: 'left',
        computed: ({ composition }) => 
            (
                composition && 
                composition.composition && 
                composition.composition.length
            ) || 0,
        fieldType: 'computed',
        sortable: 'false',
    },
    {
        text: 'Productos',
        align: 'left',
        computed: ({ composition }) => {

            return composition && composition.composition ? 
                composition.composition.map( ({ quantity_in_promo }) => quantity_in_promo ).reduce( ( prev, curr ) => prev + curr, 0 ) 
                : 
                0
        },
        fieldType: 'computed',
        sortable: 'false',
    },
]
